import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const InstagramSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={23}
    fill="none"
    {...props}
  >
    <rect
      width={21.802}
      height={21.802}
      x={0.137}
      y={0.843}
      fill="#fff"
      rx={10.901}
    />
    <path
      fill="#0C1518"
      d="M11.038 7.725h2.01c.472 0 .709.118.886.177.236.119.414.178.59.355.178.177.296.355.356.591.059.177.118.414.177.887v4.019c0 .473-.118.709-.178.886-.118.237-.177.414-.354.591a1.226 1.226 0 0 1-.591.355c-.177.059-.414.118-.887.177H9.028c-.473 0-.709-.118-.886-.177-.237-.118-.414-.178-.591-.355a1.226 1.226 0 0 1-.355-.59c-.059-.178-.118-.415-.177-.887v-4.02c0-.472.118-.709.177-.886.118-.236.177-.414.355-.59.177-.178.354-.296.59-.356.178-.059.414-.118.887-.177h2.01Zm0-.886h-2.01c-.532 0-.886.118-1.182.236a2.58 2.58 0 0 0-.886.591c-.296.296-.414.532-.591.887-.119.295-.178.65-.237 1.182v4.019c0 .532.118.886.237 1.182.118.295.295.59.59.886.296.296.533.414.887.591.296.119.65.178 1.182.237h4.02c.531 0 .886-.118 1.181-.237.296-.118.591-.295.887-.59.295-.296.414-.533.59-.887.12-.296.178-.65.237-1.182v-4.02c0-.531-.118-.886-.236-1.181a2.58 2.58 0 0 0-.591-.887c-.296-.295-.532-.414-.887-.591-.295-.118-.65-.177-1.182-.236h-2.01Z"
    />
    <path
      fill="#0C1518"
      d="M11.038 9.203a2.523 2.523 0 0 0-2.542 2.541 2.523 2.523 0 0 0 2.542 2.542 2.523 2.523 0 0 0 2.541-2.542 2.523 2.523 0 0 0-2.541-2.541Zm0 4.196c-.887 0-1.655-.71-1.655-1.655 0-.886.71-1.655 1.655-1.655.886 0 1.655.71 1.655 1.655 0 .887-.769 1.655-1.655 1.655ZM13.638 9.735a.591.591 0 1 0 0-1.182.591.591 0 0 0 0 1.182Z"
    />
  </svg>
)
export default InstagramSVG
